import { Link } from 'react-router-dom'
import { orderArrayByProperty, getBackgroundImage, shuffleArray } from '../../../utils/pageUtils'

const Grid = ({ gridData, gridPageCategory, isHome, currentLocale }) => {
    // Safety check: ensure gridData is an array
    if (!gridData || !Array.isArray(gridData)) {
        console.warn('Grid: gridData is not an array', gridData);
        return null;
    }

    const localeToUse = currentLocale || gridPageCategory?.locale || '';

    let gridPages = gridData.filter(page => {
        if (!page || typeof page !== 'object' || !page.category) {
            return false;
        }
        // only show entries for the current locale
        const localeMatch = !localeToUse || page.locale === localeToUse;
        if (!localeMatch) {
            return false;
        }
        if (isHome) {
            return page.show_in_home === true;
        }
        if (gridPageCategory && (gridPageCategory.id || gridPageCategory.documentId)) {
            return (
                page.category?.id === gridPageCategory?.id ||
                page.category?.documentId === gridPageCategory?.documentId
            );
        }
        return false;
    });

    // Deduplicate by locale + slug to avoid showing the same project multiple times per language
    const uniquePagesMap = new Map();
    gridPages.forEach(page => {
        const key = `${page.locale || 'unknown'}:${page.slug || ''}`;
        if (!uniquePagesMap.has(key)) {
            uniquePagesMap.set(key, page);
        }
    });
    gridPages = Array.from(uniquePagesMap.values());

    // Normalise order_value to keep sorting stable when values are missing
    gridPages = gridPages.map(page => ({
        ...page,
        order_value: page.order_value === null || page.order_value === undefined ? 9999 : page.order_value
    }));

    gridPages = gridPages.filter( page => page && !page.is_category_grid_page && !page.is_home )
    
    if (isHome) {
        shuffleArray(gridPages)
    } else {
        gridPages.sort(orderArrayByProperty('order_value'))
    }

    // If no pages to show, return empty div (not null) so component renders
    if (gridPages.length === 0) {
        console.warn('Grid: No pages to display', { isHome, gridPageCategory });
        return (
            <div className="container-fluid">
                <div className="row project-list">
                    <div className="col-12">
                        <p>No projects found</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row project-list">       
                    {gridPages.map((categoryPage, index) => {
                        if (!categoryPage || !categoryPage.category) {
                            console.warn('Grid: Invalid categoryPage', categoryPage);
                            return null;
                        }
                        const key = `${categoryPage.locale || 'unknown'}:${categoryPage.slug || index}`;
                        return (
                            <div key={key} className="col-sm-6 col-md-4 project-thumb">
                                <Link className="hover-on-tap" to={`/${categoryPage.locale}/${categoryPage.category.slug}/${categoryPage.slug}`}>
                                    <div className="img-container ratio-3x2">
                                        <img
                                            src={categoryPage.meta_image && getBackgroundImage(categoryPage.meta_image)}
                                            className="img-responsive"
                                            alt={categoryPage.meta_image?.alternativeText}
                                            / >
                                    </div>
                                    <div className="overlay">
                                        <div className="title">
                                            <span>{categoryPage.name}</span>
                                        </div>
                                    </div>                        
                                </Link>
                            </div>
                        );
                    })}          
                </div>
            </div>
        </>
    )
}

Grid.defaultProps = {
    gridPageCategory: 0
}

export default Grid
